import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import OutsourcedStatusEnum from '../../../Enums/OutsourcedStatusEnum';
import OutsourcedSourceTypeEnum, { OutsourcedSourceTypeLabels } from '../../../Enums/OutsourcedSourceTypeEnum';
import selectHelper from '../../../Helpers/selectHelper';
import dateTimeHelper from '../../../Helpers/datetimeHelper';

export default class OutsourcedIOBLineItemDetailSearchParams extends SearchParamsBase {
  static saveType = 'OutsourcedIOBLineItemDetailSearchParams';

  initialize() {
    this.UserIds = [];
    this.OutsourcingOfficeIds = [];
    this.FieldworkOfficeIds = [];
    this.Status = [OutsourcedStatusEnum.ReadyForInvoicing, OutsourcedStatusEnum.ApprovedForInvoicing];
    this.ClientIds = [];
    this.SurveyIds = [];
    this.TpSurveyIds = [];
    this.UseDateRange = false;
    this.StartDate = dateTimeHelper.indefiniteDateValue();
    this.EndDate = dateTimeHelper.indefiniteDateValue();
    this.IobInvoiceId = '';
    this.LineItemDetailType = '';
    this.SourceTypes = [];
  }

  static fieldsInSearchBox = [
    {
      fieldName: 'UserIds',
      label: 'User',
      className: 'col-4',
      type: InputTypesEnum.UserMultiSelect,
    },
    {
      fieldName: 'OutsourcingOfficeIds',
      label: 'Work Done By',
      className: 'col-4',
      type: InputTypesEnum.OfficeMultiSelect,
    },
    {
      fieldName: 'FieldworkOfficeIds',
      label: 'Bill To Office',
      className: 'col-4',
      type: InputTypesEnum.OfficeMultiSelect,
    },
    {
      fieldName: 'ClientIds',
      label: 'Client',
      className: 'col-4',
      type: InputTypesEnum.ClientMultiChoice,
    },
    {
      fieldName: 'SurveyIds',
      label: 'Survey',
      className: 'col-4',
      type: InputTypesEnum.SurveyMultiChoice,
    },
    {
      fieldName: 'TpSurveyIds',
      label: 'TP Survey',
      className: 'col-4',
      type: InputTypesEnum.TpSurveyMultiChoice,
    },
    {
      fieldName: 'UseDateRange',
      label: 'Use Date Range',
      className: 'col-4',
      type: InputTypesEnum.OnOff,
    },
    {
      fieldName: 'StartDate',
      label: 'Start Date',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseDateRange,
    },
    {
      fieldName: 'EndDate',
      label: 'End Date',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseDateRange,
    },
    {
      fieldName: 'IobInvoiceId',
      label: 'IOB Invoice ID',
      className: 'col-4',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'LineItemDetailType',
      label: 'Transaction Type',
      className: 'col-4',
      type: InputTypesEnum.Select,
      options: OutsourcedIOBLineItemDetailSearchParams.getLineItemDetailTypeOptions(),
    },
    {
      fieldName: 'Status',
      label: 'Status',
      className: 'col-4',
      type: InputTypesEnum.MultiChoice,
      options: OutsourcedIOBLineItemDetailSearchParams.getStatusList(),
    },
    {
      fieldName: 'SourceTypes',
      label: 'Origin',
      className: 'col-4',
      type: InputTypesEnum.MultiChoice,
      options: OutsourcedIOBLineItemDetailSearchParams.getSourceTypeList(),
    },
  ];

  static getSourceTypeList() {
    return Object.values(OutsourcedSourceTypeEnum).map((value) => ({
      value,
      label: OutsourcedSourceTypeLabels[value],
    }));
  }

  static getLineItemDetailTypeOptions() {
    return selectHelper.generateSelectValues(['', 'Addition', 'Deduction']);
  }

  static getStatusList() {
    return [
      { value: OutsourcedStatusEnum.Collected, label: 'Collected' },
      { value: OutsourcedStatusEnum.ReadyForInvoicing, label: 'Ready For Invoicing' },
      { value: OutsourcedStatusEnum.ApprovedForInvoicing, label: 'Approved For Invoicing' },
      { value: OutsourcedStatusEnum.Invoiced, label: 'Invoiced' },
      { value: OutsourcedStatusEnum.Uninvoiceable, label: 'Uninvoiceable' },
    ];
  }
}
